import { render, staticRenderFns } from "./userCredits.vue?vue&type=template&id=2e5875b8&scoped=true"
import script from "./userCredits.vue?vue&type=script&lang=js"
export * from "./userCredits.vue?vue&type=script&lang=js"
import style0 from "./userCredits.vue?vue&type=style&index=0&id=2e5875b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5875b8",
  null
  
)

export default component.exports